import styled from 'styled-components';

export const KeywordsFilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 398px;
`;
